var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Magnifier } from "@react-components/primitives/Icons/Icons";
import { DotLoader } from "@react-components/ui/Loaders/DotLoader/DotLoader";
var lang = document.documentElement.lang;
var dictionary = {
    submit: "Search",
};
if (lang === "da") {
    dictionary.submit = "Udfør søgning";
}
var SearchInput = React.forwardRef(function (_a, ref) {
    var defaultValue = _a.defaultValue, type = _a.type, className = _a.className, showLoader = _a.showLoader, rest = __rest(_a, ["defaultValue", "type", "className", "showLoader"]);
    return (_jsxs("div", __assign({ className: "search-input" }, { children: [_jsx("input", __assign({}, rest, { className: "input input--lg input--round input--icon-left input--box-shadow input--icon-right " + (className !== null && className !== void 0 ? className : ""), ref: ref, type: type !== null && type !== void 0 ? type : "search", defaultValue: defaultValue }), void 0), _jsx("div", __assign({ className: "search-input__btn-wrap" }, { children: _jsx("button", __assign({ type: "submit", "aria-label": dictionary.submit, className: "btn btn--void btn--circle btn--search btn--search search-input__btn" }, { children: _jsx(Magnifier, {}, void 0) }), void 0) }), void 0), showLoader && (_jsx("div", __assign({ className: "search-input__loader" }, { children: _jsx(DotLoader, {}, void 0) }), void 0))] }), void 0));
});
SearchInput.displayName = "SearchInput";
export { SearchInput };
